import { NO_RECIPIENT_FOUND } from "@/utils/constants/messages";
import { actionMap } from "@/utils/constants/constants";
import { DateFormatter, TimeFormatter } from "@/utils/functions/helperFunctions";

interface TemplateRecipientCardProps {
    recipients: any[];
    emptyMessage?: string;
    emptyClassName?: string;
}

const TemplateRecipientCard = ({
    recipients,
    emptyMessage = NO_RECIPIENT_FOUND,
    emptyClassName = "gs-detail-empty",
}: TemplateRecipientCardProps) => {
    const showPriority = recipients.length > 0 && !recipients.every((rec) => rec.priority === recipients[0]?.priority);

    return (
        <ul className="data-list is-compact m-0 list-none p-0">
            {recipients.length > 0 ? (
                recipients.map((rec, index) => (
                    <li key={rec.id ?? index} className="data-item" style={{ display: "block" }}>
                        <div className="data-col">
                            <div className="data-label label">
                                <div className="info">
                                    <h6 className="title" id={`template-detail-recipient-name-${index}`}>
                                        {showPriority ? (
                                            <span className="text-muted-foreground mr-1">{rec.priority}</span>
                                        ) : null}
                                        <span className="name">{`${rec.role}: ${rec.full_name}`}</span>
                                    </h6>
                                    {rec.email_address ? (
                                        <span className="text-soft" id={`template-detail-recipient-email-${index}`}>
                                            {rec.email_address}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="data-label label" aria-hidden="true" />
                            <div className="data-label label">
                                <span>
                                    <div className="info">
                                        <h6 id={`template-detail-recipient-status-${index}`}>
                                            {actionMap[rec.sign_action]}
                                        </h6>
                                        {rec.status === "current" ? (
                                            <span className="version">
                                                <span
                                                    className="text-soft"
                                                    id={`template-detail-recipient-sent-at-${index}`}
                                                >
                                                    Sent at {DateFormatter(rec.sent_at)}, {TimeFormatter(rec.sent_at)}
                                                </span>
                                            </span>
                                        ) : null}
                                    </div>
                                </span>
                            </div>
                        </div>
                    </li>
                ))
            ) : (
                <li className={emptyClassName}>
                    <p className="m-0" id="template-detail-no-recipient-data-message">
                        {emptyMessage}
                    </p>
                </li>
            )}
        </ul>
    );
};

export default TemplateRecipientCard;
